// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TimeLimitedBadge-module-timeLimitedBadge-rFRvK{display:inline-flex;flex-direction:row;align-items:center;gap:8px}.TimeLimitedBadge-module-lastDay-13TrM{padding-block:2px;padding-inline:4px 12px;background:#373a36;border-radius:8px}.TimeLimitedBadge-module-iconWhite-3SKSb{color:#fff}.TimeLimitedBadge-module-iconBlack-1CvPf{color:#373a36}.TimeLimitedBadge-module-label-328Ko{line-height:20px;letter-spacing:1.5px}", ""]);
// Exports
exports.locals = {
	"timeLimitedBadge": "TimeLimitedBadge-module-timeLimitedBadge-rFRvK",
	"lastDay": "TimeLimitedBadge-module-lastDay-13TrM",
	"iconWhite": "TimeLimitedBadge-module-iconWhite-3SKSb",
	"iconBlack": "TimeLimitedBadge-module-iconBlack-1CvPf",
	"label": "TimeLimitedBadge-module-label-328Ko"
};
module.exports = exports;
